
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-89c4e9c8\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GameOverModal.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./GameOverModal.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-89c4e9c8\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./GameOverModal.vue"),
  /* scopeId */
  "data-v-89c4e9c8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GameOverModal.vue
// module id = 37
// module chunks = 0